import {useLocation} from 'react-router'
import {ideationApi} from '../../../../../../api/ideationApi'
import styles from './IdeationTrends.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {IDEATION} from '../../../../../../Translation/English/ideation'

export const IdeationTrends: React.FC = () => {
  const wt = useWt()
  const {search} = useLocation()
  const ideationId = search ? search.substring(1) : ''
  const {data: insights} = ideationApi.useIdeationInsights(ideationId)
  const trendingTopics = insights?.trending_topics

  return (
    <div className={styles.ideationTrends}>
      <div className="ideation-section-title">
        {wt(IDEATION.trendingTopics)}
      </div>
      <div className={styles.ideationTrendsText}>
        {trendingTopics?.map((item, index) => (
          <div
            key={index}
            style={{fontSize: `${28 - index * 4}px`}}
            className={styles.ideationTrendsItem}
          >
            {' '}
            {item.topic}
          </div>
        ))}
      </div>
    </div>
  )
}
